import React from 'react';
import { Link } from 'react-router-dom';
import { drinkInfo } from './data.scoure';

export default class Detail extends React.Component {
    render() {
        const { data } = drinkInfo;
        const { drinkname } = this.props.match.params;
        const info = data.filter(data => {
            return data.title === drinkname
        })[0]; // filter會回傳list
        const image = info.detail.image;
        const DNS = "https://organic-naturetea.com/shenglongTest/asset/";
        return (
            <div class="detailbgimg text-center">
                <img src={DNS + image} alt={info.title} />
                <Link to="/" class="text-blue-500">&lt;&lt;&lt;回上一頁</Link>
            </div>
        )
    }
}